import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'
import firebase from "../../firebase/firebase-config";
import SingleMonthEarningData from './SingleMonthEarningData';

function SingleUserMonthlyEarning() {
    const params = useParams();

    const [userID, setUUser] = useState({})
    const [query, setquery] = useState('')
    const [all_EarningMonths, setall_EarningMonths] = useState([])


    async function GetMyUser() {
        try {
            const Myuser = await firebase.firestore().collection('users').doc(params.id).get();
            setUUser(Myuser.data());
            Myuser.data();
        } catch (error) {
            console.log(error);
        }



    }
    const getAllMonths = async () => {
        await firebase.firestore().collection('earnings').doc(params.id).collection('totalEarnings').onSnapshot((momnth) => {

            const allMonthsData = [];
            momnth.docs.forEach(async (monthe) => {
                await allMonthsData.push(monthe.data())
            })
            console.log(allMonthsData, 'this is sadsa');
            setall_EarningMonths(allMonthsData);
            // setAllAds(allAdsData);

        })
    }

    useEffect(() => {
        // get_all_ProductsbyUser();
        getAllMonths();
        GetMyUser();
    }, []);
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col className='col-lg-4'>
                    </Col>
                    <Col className='col-lg-4'>
                        <Card className="card-user shadow-lg">

                            <CardText />
                            <div className=" d-flex   justify-content-center  " >
                                <div className=" d-flex ">
                                    <img
                                        alt="..."
                                        className="avatar_single_user"
                                        src={userID.profilePicture}
                                    />
                                    {/* <div>{user?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}
            </div> */}
                                    <div className="ml-2 mt-2">
                                        <div className='d-flex'>
                                            <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{userID.username}</p>
                                        </div>
                                        <p className="description" style={{ fontSize: '12px' }}>{userID.fullName}</p>

                                    </div>

                                </div>
                                <div>

                                    <p className="description ml-5 bg-info px-2 ppy-1 rounded " style={{ fontSize: '14px' }}>Beyown user</p>
                                </div>


                            </div>

                        </Card>
                    </Col>
                    <Col className='col-lg-4'>
                    </Col>
                </Row>

                <div className='mt-4'>
                    <div className=" row">

                        {all_EarningMonths.filter((user_search) => user_search.month.toLowerCase().includes(query)).map((monthData, i) => (
                            // <SingleUser verificationPage={false} data={user} key={i} />
                            <SingleMonthEarningData data={monthData} id={userID?.id} />
                        ))}
                    </div>

                </div>



            </div>

        </>
    )
}

export default SingleUserMonthlyEarning